/* eslint new-cap: ["error", { "newIsCap": false }] */
import Trix from 'trix/dist/trix'
const getTribute = () => import('tributejs')

angular
  .module('deskfy.core')
  .controller('InputTextRichController', InputTextRichController)

/* @ngInject */
function InputTextRichController ($scope, $sce, $element, $timeout, $compile, $translate, $window, TrixEditorService, Utils) {
  $scope.valueCopy = $scope.value ? `${$scope.value}` : ''

  let _richTextEditor
  let _annotation

  const api = {
    _initializeEditor,
    _initializeAnnotation,
    _checkForLinks
  }
  this.getApi = () => api

  activate()
  function activate () {
    $timeout(() => {
      jQuery('.input-text-rich-tooltip').popup()
    }, 0, false)
    api._checkForLinks()
  }

  $scope.$watch('value', (newVal) => {
    if (newVal) {
      const stringReplace = newVal.replace('<a href', '<a target="_blank" href')
      $scope.formattedValue = $sce.trustAsHtml(stringReplace)
    }
  })

  $scope.$watch('annotationOptions.values', (values) => {
    if (values && values.length) {
      $timeout(() => api._initializeAnnotation(), 0, false)
    }
  })

  $scope.handleRichTextEditorInit = function (e, editor) {
    _richTextEditor = editor
    TrixEditorService.trixAutoLinker(e.target)

    if ($scope.initializeAfterPromise) {
      $scope.initializeAfterPromise.then(() => {
        api._initializeEditor()
      })
    } else {
      api._initializeEditor()
    }
  }

  $scope.handleRichTextFieldFocus = function (e, editor) {
    if ($scope.focus) {
      $scope.focus($scope.model, e)
    }

    if ($scope.hideToolbar) {
      $timeout(() => {
        jQuery(_richTextEditor.composition.delegate.toolbarController.element).addClass('show')
      }, 150, false)
    }
  }

  $scope.handleRichTextFieldBlur = function (e, editor) {
    if ($scope.blur) {
      $scope.blur($scope.model, e)
    }

    if ($scope.hideToolbar && !jQuery(document.activeElement).hasClass('trix-input')) {
      $timeout(() => {
        jQuery(_richTextEditor.composition.delegate.toolbarController.element).removeClass('show')
      }, 150, false)
    }
  }

  $scope.onChange = function (newValue) {
    if ($scope.maxLength && $scope.maxLength > 0 && _richTextEditor.getDocument().getLength() > $scope.maxLength) {
      _richTextEditor.setSelectedRange([$scope.maxLength, _richTextEditor.getDocument().getLength()])
      _richTextEditor.insertHTML('')
    }

    if ($scope.change) {
      $scope.change({
        modelPropertyName: $scope.modelPropertyName,
        modelNewValue: newValue
      })
    }
  }

  $scope.onClick = (event) => {
    const isAnchor = event.target.tagName === 'A'

    if (isAnchor) {
      const anchorHref = event.target.href
      $window.open(anchorHref, '_blank')
    }
  }

  function _initializeEditor () {
    if (!$scope.hideToolbar) {
      jQuery(_richTextEditor.composition.delegate.toolbarController.element).addClass('show')
    }
    if ($scope.simpleToolbar) {
      jQuery(_richTextEditor.composition.delegate.toolbarController.element).addClass('simple')
    }
    if ($scope.buttons) {
      const div = jQuery($compile('<div class="right-buttons"></div>')($scope))
      $element.find('.trix-button-row').append(div)
      $element.find('.trix-button-group--file-tools').css({ display: 'none' }) // remove attachment button from trix toolbar

      $scope.buttons.forEach(button => {
        const element = jQuery($compile(`<button data-trix-action="''" tabindex="-1" class="ui trix-button-group ${button.className}" data-variation="inverted tiny"></button>`)($scope))

        if (button.tooltip) {
          element.attr('data-content', $translate.instant(button.tooltip))
        }

        button.addTooltip = (name) => {
          element.attr('data-content', $translate.instant(name))
        }

        if (button.iconName) {
          const icon = document.createElement('i')
          icon.classList.add(button.iconName)
          element.append(icon)
        }

        if (button.svgName) {
          const svgIcon = $compile(`<svg-icon name="${button.svgName}"></svg-icon>`)($scope)
          element.html(svgIcon)
        }

        button.addClass = (className) => element.addClass(className)
        button.removeClass = (className) => element.removeClass(className)

        element.on('click', function (event) {
          button.onClick(event)
        })

        if (button.position === 'right') {
          $element.find('.trix-button-row .right-buttons').append(element)
        } else {
          $element.find('.trix-button-group').first().append(element)
        }

        if (button.tooltip) {
          element.popup({
            position: button.tooltipPosition,
            inline: button.tooltipInline
          })
        }
      })
    }
  }

  function _initializeAnnotation () {
    if (_annotation) {
      return
    }
    const trix = $element.find('trix-editor')[0]
    const options = $scope.annotationOptions

    getTribute().then((TributeModule) => {
      _annotation = new TributeModule.default({
        lookup: options.lookup,
        menuItemTemplate: options.menuItemTemplate,
        selectTemplate: function (item) {
          const html = options.selectTemplate(item)

          _annotation.range.pasteHtml = function (html, startPos, endPos) {}

          const attachment = new Trix.Attachment({
            contentType: 'text/html',
            content: html,
            item: item.original
          })

          const matchSize = (item.string.match(/<span>/g) || []).length + 1

          for (let i = 0; i < matchSize; i++) {
            trix.editor.deleteInDirection('backward')
          }

          const range = trix.editor.getSelectedRange()
          const from = range[0]
          const to = range[1] + 1

          trix.editor.setSelectedRange([from, to])
          trix.editor.insertAttachment(attachment)

          if (options.onSelect) {
            options.onSelect(attachment.attributes.values.item)
          }
        },
        values: options.values
      })

      trix.addEventListener('trix-attachment-remove', function (e) {
        const value = e.attachment.attachment.attributes.values.item

        if ($scope.annotationOptions) {
          $scope.annotationOptions.onRemove(value)
        }
      })
      _annotation.attach(trix)
    })
  }

  function _checkForLinks () {
    const result = Utils.processTextsWithLinks([$scope.label, $scope.description])
    $scope.labelWithLinks = result[0]
    $scope.descriptionWithLinks = result[1]
  }
}
